import React from 'react';

export const polyfillScripts = (
  <>
    {/* Polyfill old javascript stuff */}
    <script
      src={`https://polyfill.io/v3/polyfill.min.js?features=es5,es2015,es2016,es2017`}
    />
    {/* es2018 can crash in some browsers due to asyncIterator, so we separate it  */}
    <script src={`https://polyfill.io/v3/polyfill.min.js?features=es2018`} />
    {/* Polyfill modern javascript stuff */}
    <script
      src={`https://polyfill.io/v3/polyfill.min.js?features=es2019,es2020,es2021,String.prototype.normalize`}
    />
    {/* Polyfill Intl */}
    <script src={`https://polyfill.io/v3/polyfill.min.js?features=Intl`} />
    {/* Polyfill setImmediate */}
    <script
      src={`https://polyfill.io/v3/polyfill.min.js?features=setImmediate`}
    />
  </>
);
